import { all, takeEvery } from 'redux-saga/effects';
import { authRequired } from 'services/auth/sagas';
import { serviceSaga } from 'services/sagaWorkers';
import { orderManagementReturnsApiSelector } from 'app/api/selectors-production';
import { ACTIONS } from './constants';

const fetchReturnsWatcher = action =>
  serviceSaga(orderManagementReturnsApiSelector, 'getReturnsData', action);

const postAddNewReturn = action =>
  serviceSaga(orderManagementReturnsApiSelector, 'addReturn', action);


export default function* orderManagementReturnSagas() {
  yield all([
    takeEvery(
      [ACTIONS.FETCH_RETURNS, ACTIONS.FETCH_RETURNS_CSV],
      authRequired,
      fetchReturnsWatcher,
    ),
    takeEvery(ACTIONS.POST_ADD_NEW_RETURN, authRequired, postAddNewReturn),
  ]);
}
